export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const RESET_USER_PASSWORD_SUCCESSFUL = 'RESET_USER_PASSWORD_SUCCESSFUL';

export const RESET_USER_PASSWORD_API_FAILED = 'RESET_USER_PASSWORD_API_FAILED';